import { Tab, Nav, Card, CardBody, Button } from 'react-bootstrap';
import InformationsGeneralesTab from "../../components/Tabs/ClientTabs/InformationsGeneralesTab";
import TicketsTab from "../../components/Tabs/ClientTabs/TicketsTab";
import LiensTab from "../../components/Tabs/ClientTabs/LiensTab";
import StatistiquesTab from "../../components/Tabs/ClientTabs/StatistiquesTab";
import ProjetsTab from "../../components/Tabs/ClientTabs/ProjetsTab";
import { useClient } from "../../hooks/useGetClientById";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";

const Client = () => {
  const { hasPermission } = useAuth();
  // Get clientId from the route params (react-router)
  const { clientId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Extract navigation state
  const fromList = location.state?.from || '/clients';
  const listState = location.state?.listState;

  // Custom hook to fetch client data by id (returns typical react-query shape)
  const { data, isLoading, isError } = useClient(clientId);

  // The API response payload is expected under `data.data`
  const client = data?.data;

  // Show a simple loading state while fetching
  if (isLoading) return <div>Chargement...</div>;

  // Handle error or missing client
  if (isError || !client) return <div>Client non trouvé</div>;

  // Normalize the active flag to a boolean (some APIs return 1/0)
  const isActive = Number(client.is_active) === 1;

  return (
    <>
      {/* Back button */}
      {fromList && (
        <Button
          variant="link"
          className="mb-2 ps-0 btn-topbar-icon"
          onClick={() => navigate(fromList, { state: { listState } })}
        >
          <FaArrowLeft className="me-2" /> Retour à la liste
        </Button>
      )}

      {/* Card header showing client name and inactive badge when appropriate */}
      <Card className="border-left-primary shadow mt-3 mb-5 w-5a0">
        <CardBody>
          <div className="d-sm-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <h1 className="h3 mb-0 text-gray-800">{client.name}</h1>
              {!isActive && (
                <span className="badge bg-secondary ms-2" style={{ fontSize: 12 }}>
                  Inactif
                </span>
              )}
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Tabs for client sections; InformationsGeneralesTab receives the client object */}
      <Tab.Container defaultActiveKey="informationsGenerales">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="informationsGenerales">Informations générales</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="tickets">Tickets</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="projets">Projets</Nav.Link>
          </Nav.Item>
          {hasPermission('SEE_STATS') && (
            <Nav.Item>
              <Nav.Link eventKey="statistiques">Statistiques</Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item>
            <Nav.Link eventKey="liens">Liens</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className="mt-4">
          <Tab.Pane eventKey="informationsGenerales">
            {/* Pass client data down to the informations tab for display/edit */}
            <InformationsGeneralesTab client={client} />
          </Tab.Pane>
          <Tab.Pane eventKey="tickets">
          <TicketsTab client={client} />
        </Tab.Pane>
          <Tab.Pane eventKey="projets">
            <ProjetsTab clientId={Number(clientId)} clientName={client.name} />
          </Tab.Pane>
          {hasPermission('SEE_STATS') && (
            <Tab.Pane eventKey="statistiques">
              <StatistiquesTab client={client} />
            </Tab.Pane>
          )}
          <Tab.Pane eventKey="liens">
            <LiensTab client={client} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};


export default Client;